import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// ──────────────────────────────────────────────────────────────────────────
// Selector de doble lista ("Alternativas disponibles" / "Alternativas
// seleccionadas" + botones para mover con las flechas) — boceto del paso 4
// (Feedback) compartido por Jody, 26/08/2026. No existía un componente
// equivalente en el resto de la app (se revisó `CargosMultiselect.jsx` de
// evaluacionesProcesos, pero es un checklist con "Seleccionar todos", no una
// doble lista), así que este es nuevo — genérico, para poder reutilizarlo si
// aparece el mismo patrón en otra pantalla.
//
// Uso: `available`/`selected` son arrays de {value, label}; un ítem nunca
// está en las dos listas a la vez. Clic en un ítem lo resalta (selección
// múltiple simple, sin Ctrl/Shift); ">" mueve los resaltados de disponibles
// a seleccionados, "<" los mueve de vuelta.
// ──────────────────────────────────────────────────────────────────────────
const TransferList = ({ available, selected, onChange, labelAvailable = "Alternativas disponibles", labelSelected = "Alternativas seleccionadas" }) => {
    const [highlightedAvailable, setHighlightedAvailable] = useState([]);
    const [highlightedSelected, setHighlightedSelected] = useState([]);

    const toggleHighlight = (value, highlighted, setHighlighted) => {
        setHighlighted(highlighted.includes(value) ? highlighted.filter(v => v !== value) : [...highlighted, value]);
    }

    const handleMoveRight = () => {
        if (highlightedAvailable.length === 0) return;
        const moved = available.filter(o => highlightedAvailable.includes(o.value));
        onChange({
            available: available.filter(o => !highlightedAvailable.includes(o.value)),
            selected: [...selected, ...moved],
        });
        setHighlightedAvailable([]);
    }

    const handleMoveLeft = () => {
        if (highlightedSelected.length === 0) return;
        const moved = selected.filter(o => highlightedSelected.includes(o.value));
        onChange({
            available: [...available, ...moved],
            selected: selected.filter(o => !highlightedSelected.includes(o.value)),
        });
        setHighlightedSelected([]);
    }

    return (
        <div className="d-flex align-items-stretch" style={{ gap: "12px" }}>
            <TransferListColumn label={labelAvailable} options={available} highlighted={highlightedAvailable}
                onItemClick={(value) => toggleHighlight(value, highlightedAvailable, setHighlightedAvailable)} />

            <div className="d-flex flex-column justify-content-center" style={{ gap: "8px" }}>
                <button type="button" className="btn generic-button-buscador" title="Mover a seleccionadas" onClick={handleMoveRight}>
                    <FontAwesomeIcon icon="chevron-right" />
                </button>
                <button type="button" className="btn generic-button-buscador" title="Quitar de seleccionadas" onClick={handleMoveLeft}>
                    <FontAwesomeIcon icon="chevron-left" />
                </button>
            </div>

            <TransferListColumn label={labelSelected} options={selected} highlighted={highlightedSelected}
                onItemClick={(value) => toggleHighlight(value, highlightedSelected, setHighlightedSelected)} />
        </div>
    )
}

const TransferListColumn = ({ label, options, highlighted, onItemClick }) => (
    <div className="flex-fill">
        <label className="modal-label d-flex">{label}</label>
        <div className="form-control custom-scroll" style={{ height: "180px", overflowY: "auto", padding: "4px" }}>
            {options.length === 0 && <div className="text-muted text-center mt-2" style={{ fontSize: "0.85em" }}>(vacío)</div>}
            {options.map((option) => (
                <div key={option.value}
                    className="hand-pointer"
                    onClick={() => onItemClick(option.value)}
                    style={{
                        padding: "4px 8px",
                        borderRadius: "4px",
                        backgroundColor: highlighted.includes(option.value) ? "#e3f2fd" : "transparent",
                    }}>
                    {option.label}
                </div>
            ))}
        </div>
    </div>
)

export default TransferList
